// extracted by mini-css-extract-plugin
module.exports = {"support":"index_support__3QXVw","supportContact":"index_supportContact__24nxD","privacyPolicy":"index_privacyPolicy__2VmuH"};